module.exports = __webpack_public_path__ + "img/dev.81a1c484.png";